"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_chart__bar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "chart-bar-hi"), /*#__PURE__*/React.createElement("g", {
    id: "f7cc1224-11a2-4c5c-b521-c22ca4fdc1ac",
    "data-name": "bar-chart-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b21ca02c-46bb-417c-aae6-4f9ce165ef63",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2a3c2c09-8738-4a99-a08e-df14e6c1cc9f",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9f802d50-d023-40bb-80a1-a58e7d61b158",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12150b07-7a2a-4c8b-80fa-84860217cbec",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "853f04f5-0629-46f1-a834-3c11a8cd5891",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2658066b-08e3-45f2-92c0-622eae948cac",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "38dbcb36-e8a2-433e-a19c-ecbcc4d99bc9",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "30a6afb0-ddee-4db7-ae41-53b04a50dc77",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8b545a71-0680-45e8-856b-59e28d241d6c",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "30f7f380-2069-43f5-ab03-3ce31dee535a",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ba2ffe24-8def-4e8d-8e50-7895b952308a",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6397b538-29bb-48a9-b9f9-a8ddb169c366",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ee296d6a-3257-48ab-b9dc-80556e9df247",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5f81906c-2e88-4c05-a825-c6664c5b0771",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a6cfa06f-c75e-4c75-b6c2-adf0274a451f",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aba1c36c-ae38-4240-91a7-f78447e42503",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9331196c-ae1f-4b1a-bb8d-b9989f5d3ea6",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5b88daf4-1ea9-4e97-8cff-cda2eabc8c63",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e1f31347-82b7-4f67-b3c8-35210d0bc69f",
    "data-name": "Minutes_sms_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c28f09f0-7434-4352-bdf3-c240bb72f7c9",
    "data-name": "Bar_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 144,
    height: 144,
    rx: 16,
    ry: 16,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16v-2A16,16,0,0,1,152,166Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,127.89H58A1.89,1.89,0,0,1,56.11,126V90A1.89,1.89,0,0,1,58,88.11H74A1.89,1.89,0,0,1,75.89,90v36A1.89,1.89,0,0,1,74,127.89Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,127.89H118a1.89,1.89,0,0,1-1.89-1.89V72A1.89,1.89,0,0,1,118,70.11h16A1.89,1.89,0,0,1,135.89,72v54A1.89,1.89,0,0,1,134,127.89Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,127.89H58A1.89,1.89,0,0,1,56.11,126V90A1.89,1.89,0,0,1,58,88.11H74A1.89,1.89,0,0,1,75.89,90v36A1.89,1.89,0,0,1,74,127.89Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,127.89H118a1.89,1.89,0,0,1-1.89-1.89V72A1.89,1.89,0,0,1,118,70.11h16A1.89,1.89,0,0,1,135.89,72v54A1.89,1.89,0,0,1,134,127.89Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,127.89H88A1.89,1.89,0,0,1,86.11,126V54A1.89,1.89,0,0,1,88,52.11h16A1.89,1.89,0,0,1,105.89,54v72A1.89,1.89,0,0,1,104,127.89Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,140H50a2,2,0,0,1,0-4h92a2,2,0,0,1,0,4Z",
    fill: "#4a4d4e"
  })))))))))))))))))))))));
}

var _default = ic_chart__bar;
exports.default = _default;